import { SuretyAccountId } from "@inrev/common";
import { Card, Text } from "@portal/components/primitives";
import { useCallback, useState } from "react";
import { match } from "ts-pattern";
import { useAccountTabsNavigation } from "../../../../account/useAccountTabNavigation";
import { AgentActionItemsTable } from "../../../shared/action-items/AgentActionItemsTable";
import { type ActionItemModalState, ActionItemModals } from "./ActionItemModals";
import type { ActionItem } from "./types";
import { useActionItems } from "./useActionItems";

export const ActionItemsSection = ({ accountId }: { accountId: SuretyAccountId }) => {
	const { items } = useActionItems(accountId);
	const navigateTabs = useAccountTabsNavigation();
	const [modalState, setModalState] = useState<ActionItemModalState>(null);

	const handleActionClick = useCallback(
		(row: ActionItem) => {
			if (!row.action) return;
			match(row.action)
				.with({ type: "navigate" }, ({ navigate }) => {
					navigateTabs(navigate);
				})
				.with({ type: "upload" }, ({ periodEndDate, periodType }) => {
					setModalState({ kind: "upload", periodEndDate, periodType });
				})
				.with({ type: "profitability" }, ({ fields }) => {
					setModalState({ kind: "profitability", fields });
				})
				.with({ type: "blocSize" }, ({ fyeDate }) => {
					setModalState({ kind: "blocSize", fyeDate });
				})
				.exhaustive();
		},
		[navigateTabs],
	);

	return (
		<>
			{items.length > 0 && (
				<Card
					elevation="raised"
					className="rounded-xl"
					data-testid="agent-account-action-items-card"
				>
					<Card.Body className="flex flex-col space-y-5 p-6">
						<Text type="title" color="primary">
							Action Items
						</Text>
						<AgentActionItemsTable rows={items} onActionClick={handleActionClick} />
					</Card.Body>
				</Card>
			)}
			<ActionItemModals
				accountId={accountId}
				state={modalState}
				onClose={() => setModalState(null)}
			/>
		</>
	);
};
